import {
  styled,
  css,
  Box,
  Button,
  BoxProps,
  TextFieldProps,
  alpha
} from '@mui/material'
import Tags from '../Tags'
import Text from '../Text'
import { HeaderListLabelWrapperProps } from './HeaderList.types'
import getPaletteColor from '../../../utils/getPaletteColor'

export const HeaderListWrapper = styled(Box)(
  () => css`
    padding-top: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  `
)

export const HeaderListLabelWrapper = styled(Box)<
  BoxProps & HeaderListLabelWrapperProps
>(
  ({ iconLabelPosition, theme, hasIconLabel }) => css`
    height: 30px;
    display: flex;
    align-items: center;
    gap: 4px;
    flex-direction: ${iconLabelPosition};
    background-color: ${hasIconLabel
      ? alpha(getPaletteColor(theme, theme.palette.primary.main), 0.1)
      : 'transparent'};
    .Icon {
      color: ${theme.palette.primary.main};
    }
    padding: 10px 8px;
    border-radius: 12px;
  `
)

export const HeaderListLabel = styled(Text)<TextFieldProps>(
  ({ theme }) =>
    css`
      color: ${theme.palette.primary.main};
      font-weight: 600;
    `
)

export const HeaderTags = styled(Tags)(
  () => css`
    flex: 1;
  `
)

export const TextButton = styled(Button)(
  ({ theme }) => css`
    text-align: right;
    color: ${theme.palette.primary.main};
    font-weight: ${theme.typography.fontWeightBold};
    text-decoration: underline;
    font-size: 0.78rem;
  `
)
